import { CtfAppInstanceParameters } from '../types';
import { getCtfAppSdk } from './get-ctf-app-sdk';

export const getAppInstanceParam = (
  paramName: keyof CtfAppInstanceParameters,
) => {
  const appInstanceParameters = getCtfAppSdk()?.parameters
    .instance as CtfAppInstanceParameters;

  return appInstanceParameters[paramName];
};

export default getAppInstanceParam;
